import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE } from 'loyalty/constants/loyaltySearchFilters'
import { CHOOSE_DOUBLE_REWARDS_CAMPAIGN_TAG } from 'takeovers/loyaltyChooseDoubleRewardsTakeover/loyaltyChooseDoubleRewardsTakeover.constants'

function useLoyaltyFilterLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const getLabel = (value: string): string => {
      if (value === CHOOSE_DOUBLE_REWARDS_CAMPAIGN_TAG) {
        return intl.formatMessage({
          id: 'UQT9cNYiojiDt_oAtIiq',
          defaultMessage: 'Double Rewards',
          description: 'Label for the Double Rewards campaign in recent hotel search filters',
        })
      }
      if (value === LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE) {
        return intl.formatMessage({
          id: 'cAuUythHUuZT7-LgxYEi',
          defaultMessage: 'Free upgrade',
          description: 'Display label for Free Room Upgrade loyalty filter',
        })
      }
      return value
    }

    return { getLabel }
  }, [intl])
}

export default useLoyaltyFilterLabels
